// 1*10^18 wei in ether, so this is 0.001 ether
export const MIN_WITHDRAWABLE_WEI = BigInt(1e15);

export function isWithdrawableBalance(balance: bigint | string) {
  return BigInt(balance) >= MIN_WITHDRAWABLE_WEI;
}

export function bigIntToNumber(value: bigint, { strict }: { strict: boolean }): number {
  const numberValue = Math.min(Number(value), Number.MAX_SAFE_INTEGER);

  if (strict && String(value) !== String(numberValue))
    throw Error(
      `Big Int ${value.toString()} can't be parsed as number due to maximum value reached`,
    );

  return numberValue;
}
